import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Settings } from 'lucide-react';
import './Breadcrumbs.css';

/**
 * Breadcrumbs component for navigation
 * @param {Object} props
 * @param {Array<{label: string, path?: string}>} props.items - Breadcrumb items
 */
const Breadcrumbs = ({ items }) => {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumbs-list">
        {/* Always start with Settings link */}
        <li className="breadcrumbs-item">
          <Link to="/settings" className="breadcrumbs-link">
            <Settings size={16} className="breadcrumbs-icon" />
            Settings
          </Link>
        </li>

        {items.map((item, index) => (
          <React.Fragment key={index}>
            <li className="breadcrumbs-separator">
              <ChevronRight size={16} />
            </li>
            <li className="breadcrumbs-item">
              {item.path && index < items.length - 1 ? (
                <Link to={item.path} className="breadcrumbs-link">
                  {item.label}
                </Link>
              ) : (
                <span className="breadcrumbs-current">{item.label}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
